import { TypeOptions, UpdateOptions } from "react-toastify";

export enum LOCALSTORAGE_KEY {
  BUILD_VERSION = "BUILD_VERSION",
}

export type TWordBreakType = "normal" | "break-all" | "keep-all" | "break-word";

export type TAlignText = "left" | "right";

export const AUTH_COOKIES_KEY = {
  TOKEN: "ATK",
  REFRESH_TOKEN: "RTK",
};

export const TOKEN_EXPIRED_MESSAGES = ["authorization token has expired"];
export const ERROR_NON_LOGOUT_MESSAGES = [
  "please use correct username/password",
  "permission denied",
];

export enum EENV {
  DEV = "development",
  QA = "qa",
  UAT = "uat",
  PROD = "production",
}

export enum EACOUNT_TYPE {
  SUPERADMIN = "super_admin",
  EMPLOYEE = "employee",
}

export const TOAST_CLOSE_TIME = 2000;

export const TOAST_DATA = (type: TypeOptions): UpdateOptions => ({
  type: type,
  autoClose: TOAST_CLOSE_TIME,
  isLoading: false,
  className: "toast-error",
});

export const LANGUAGE_MAP = {
  JA: "ja",
  EN: "en",
};

export const LANGUAGE_LABEL = {
  [LANGUAGE_MAP.JA]: "Japanese",
  [LANGUAGE_MAP.EN]: "English",
};

export const SUPPORTED_LANGUAGES = [
  {
    value: LANGUAGE_MAP.JA,
    label: LANGUAGE_LABEL[LANGUAGE_MAP.JA],
  },
  {
    value: LANGUAGE_MAP.EN,
    label: LANGUAGE_LABEL[LANGUAGE_MAP.EN],
  },
];

export const DEFAULT_VALUE = {
  COUNTRY: "Japan",
  ISD_CODE: "+81", //Japan
  LOCALE: "en-US",
  LANGUAGE: "ja", //Japanese,
  CURRENCY: "jpy", // Japanese Yen
};

export const MAP_LOCALE: Record<string, string> = {
  "en-GB": DEFAULT_VALUE.LOCALE,
};

export const MAIN_LAYOUT_ID = "main-layout";

export const API_DATE_FORMAT = "yyyy-MM-dd";

// 1000000KB = 1MB
export const KB_MB_SIZE = 1000000;

export const DEFAULT_DATE_FORMAT = "yyyy/MM/dd";

export const DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";

export const DATE_TIME_FORMAT_WITHOUT_SECONDS = "yyyy/MM/dd HH:mm";

export const DATE_TIME_ISO_STRING_FORMAT = "yyyy-MM-dd'T'HH:mm:ssX";

export const DAY_ORDER: Record<string, number> = {
  sunday: 1,
  monday: 2,
  tuesday: 3,
  wednesday: 4,
  thursday: 5,
  friday: 6,
  saturday: 7,
};

export enum EInterviewModalTab {
  INTERVIEW_NOTES = "INTERVIEW_NOTES",
  TICKET_DETAILS = "TICKET_DETAILS",
}

export const INTERVIEW_MODAL_TAB_OPTIONS = [
  { value: EInterviewModalTab.INTERVIEW_NOTES, label: "interview_or_notes" },
  { value: EInterviewModalTab.TICKET_DETAILS, label: "ticket" },
];

export const MISSING_JAPANESE_TRANSLATION_MESSAGE =
  "(Missing Japanese Translation)";
